function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-reply_svg__a",
  d: "M20.603 10.976C17.707 7.973 13.824 7.29 12 7.136V3a.999.999 0 00-1.625-.781l-10 8a1 1 0 000 1.562l10 8a.998.998 0 001.058.12A1 1 0 0012 19v-4.062c3.761.145 6.54 1.104 8.244 2.877 1.823 1.895 1.76 4.049 1.757 4.133-.028.55.394 1.02.943 1.05.019.002.038.002.057.002a1 1 0 00.997-.941c.279-4.73-.864-8.458-3.395-11.083"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("use", {
  fillRule: "evenodd",
  xlinkHref: "#icon-reply_svg__a"
});

var SvgIconReply = function SvgIconReply(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgIconReply;